// extracted by mini-css-extract-plugin
export var arrowButton = "DoctorCarousel-module--arrowButton--bi5fl";
export var arrowDisabled = "DoctorCarousel-module--arrowDisabled--6kXwO";
export var carouselArrows = "DoctorCarousel-module--carouselArrows--Newwy";
export var carouselContainer = "DoctorCarousel-module--carouselContainer--HmkhN";
export var carouselControls = "DoctorCarousel-module--carouselControls--beX8O";
export var carouselDots = "DoctorCarousel-module--carouselDots--qVIxK";
export var carouselSlide = "DoctorCarousel-module--carouselSlide--IB68X";
export var carouselTrack = "DoctorCarousel-module--carouselTrack--u40Nu";
export var carouselWrapper = "DoctorCarousel-module--carouselWrapper--9NvsY";
export var dot = "DoctorCarousel-module--dot--h0DYV";
export var dotActive = "DoctorCarousel-module--dotActive--KvZuX";